<hr style="margin-top: 0px; margin-bottom: 0px;">

<!-- Custom Fullscreen Image Viewer with Zoom & Pan -->
<div *ngIf="showFullscreenViewer" class="fullscreen-viewer-overlay" (wheel)="onViewerWheel($event)" (mouseup)="onViewerMouseUp()" (mousemove)="onViewerMouseMove($event)" (mouseleave)="onViewerMouseUp()">
    <div class="fullscreen-viewer-toolbar">
        <button class="viewer-btn" (click)="viewerZoomIn()" title="Zoom In"><i class="fa fa-search-plus"></i></button>
        <button class="viewer-btn" (click)="viewerZoomOut()" title="Zoom Out"><i class="fa fa-search-minus"></i></button>
        <span class="viewer-zoom-label">{{ (viewerZoomLevel * 100) | number:'1.0-0' }}%</span>
        <button class="viewer-btn" [ngClass]="{'viewer-btn-active': viewerBoxZoomMode}" (click)="toggleBoxZoomMode()" title="Box Zoom"><i class="fa fa-crop"></i></button>
        <button class="viewer-btn" (click)="viewerResetView()" title="Reset"><i class="fa fa-undo"></i></button>
        <button class="viewer-btn viewer-btn-close" (click)="closeFullscreenViewer()" title="Close"><i class="fa fa-times"></i></button>
    </div>
    <div class="fullscreen-viewer-container">
        <div *ngIf="viewerImageLoading" style="display: flex; align-items: center; gap: 10px;">
            <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="color: white;"></i>
            <span style="color: white; font-size: 16px;">Loading...</span>
        </div>
        <img *ngIf="!viewerImageLoading && viewerImageSrc"
             [src]="viewerImageSrc"
             [style.transform]="'scale(' + viewerZoomLevel + ') translate(' + viewerPanX + 'px, ' + viewerPanY + 'px)'"
             [style.cursor]="viewerBoxZoomMode ? 'crosshair' : (viewerZoomLevel > 1 ? 'grab' : 'default')"
             (mousedown)="onViewerMouseDown($event)"
             draggable="false"
             class="fullscreen-viewer-image"
             alt="Fullscreen preview" />
        <div *ngIf="boxZoomActive" class="box-zoom-selection"
             [style.left.px]="getBoxRect().left"
             [style.top.px]="getBoxRect().top"
             [style.width.px]="getBoxRect().width"
             [style.height.px]="getBoxRect().height"></div>
    </div>
</div>

<p-confirmDialog key="cd1" #cd1>
    <ng-template #footer>
        <button type="button" class="btn btn-success" (click)="cd1.onAccept()">Yes</button>
        <button type="button" class="btn btn-basic" (click)="cd1.onReject()">No</button>
    </ng-template>
</p-confirmDialog>

<p-confirmDialog key="cdLoadCount" #cdLoadCount>
    <ng-template #footer>
        <button type="button" class="btn btn-success" (click)="cdLoadCount.onAccept()">Newest 100</button>
        <button type="button" class="btn btn-primary" (click)="cdLoadCount.onReject()">Oldest 100</button>
    </ng-template>
</p-confirmDialog>

<div *ngIf="showMediaGallery" class="card flex justify-content-center">
    <p-galleria [(value)]="mediaGallery" [(visible)]="showMediaGallery" [showIndicators]="true" [showThumbnails]="false" [responsiveOptions]="responsiveOptions" [containerStyle]="{ 'max-width': '90%' }" [numVisible]="5" [circular]="true" [fullScreen]="true" [showItemNavigators]="true" (visibleChange)="mediaGalleryVisibilityChanged($event)" >
        <ng-template pTemplate="item" let-item>
            <img [src]="item.itemImageSrc" style="width: 100%; display: block;" />
        </ng-template>
        <ng-template pTemplate="thumbnail" let-item>
            <div class="grid grid-nogutter justify-content-center">
                <img [src]="item.thumbnailImageSrc" style="display: block;" />
            </div>
        </ng-template>
    </p-galleria>
</div>

<div style="padding-top: 15px; padding-bottom: 15px;">
    <label style="font-size: 18px; color:black; padding-left: 20px; padding-right: 15px; padding-top: 5px; font-weight: 500;">SCOUTVIEW </label>
    <button (click)="refreshImageList()" style="height: 35px; padding-top: 4px; margin-right: 15px; margin-left: 195px;" class="btn btn-primary" type="button">Refresh</button>
    <input type="file" #fileUploadInput accept="image/*" style="display: none;" (change)="onImageFileSelected($event)" />
    <button [disabled]="!selectedImageDevice" (click)="fileUploadInput.click()" style="height: 35px; padding-top: 4px; margin-right: 15px;" class="btn btn-success" type="button">Upload Image</button>

    <button *ngIf="!allImagesSelected" [disabled]="searchedScoutviews.length < 1" (click)="selectAllDisplayedScoutviews()" style="height: 35px; padding-top: 4px; margin-right: 15px; float: right;" class="btn btn-primary" type="button">Select All</button>
    <button *ngIf="allImagesSelected" [disabled]="searchedScoutviews.length < 1" (click)="unSelectAllDisplayedScoutviews()" style="height: 35px; padding-top: 4px; margin-right: 15px; float: right;" class="btn btn-primary" type="button">Unselect All</button>

    <div style="float: right; display: inline-flex; align-items: center; gap: 8px; margin-right: 15px;">
        <span style="font-size: 14px; font-weight: 500;">Bulk Actions</span>
        <div class="bulk-actions-box">
            <button class="bulk-icon-btn" pTooltip="Run Pipeline" tooltipPosition="top"
                    [disabled]="!scoutviewsSelected || !selectedImageDevice || !selectedImageDevice.userFeatureAccess['EditDevice']"
                    (click)="choosePipelineToRunOnSelectedMedia(runPipelineOnSelectedTemplate)"><i class="fa-solid fa-play"></i></button>
            <button class="bulk-icon-btn" pTooltip="Update Tags" tooltipPosition="top"
                    [disabled]="!scoutviewsSelected || !selectedImageDevice || !selectedImageDevice.userFeatureAccess['EditDevice']"
                    (click)="updateMetadataTags(metadataTagsTemplate)"><i class="fa-solid fa-tags"></i></button>
            <button class="bulk-icon-btn delete" pTooltip="Delete Selected" tooltipPosition="top"
                    [disabled]="!scoutviewsSelected || !selectedImageDevice || !selectedImageDevice.userFeatureAccess['EditDevice']"
                    (click)="deleteSelectedScoutviews()"><i class="fa-solid fa-trash"></i></button>
            <button class="bulk-icon-btn" pTooltip="View Selected" tooltipPosition="top"
                    [disabled]="!scoutviewsSelected" (click)="openSelectedImagesInGallery()"><i class="fa-solid fa-eye"></i></button>
            <button class="bulk-icon-btn" pTooltip="Download Selected" tooltipPosition="top"
                    [disabled]="!scoutviewsSelected" (click)="downloadSelectedImages()"><i class="fa-solid fa-download"></i></button>

            <span style="margin-left: 6px; font-size: 12px;">Expiration</span>
            <div class="bulk-expiration"
                 [class.disabled]="!scoutviewsSelected || !selectedImageDevice || !selectedImageDevice.userFeatureAccess['EditDevice']">
                <div class="minusCircle" (click)="adjustExpirationDateForSelected(-90)">90</div>
                <div class="minusCircle" (click)="adjustExpirationDateForSelected(-30)">30</div>
                <div class="minusCircle" (click)="adjustExpirationDateForSelected(-7)">7</div>
                <div style="margin-left: 6px; margin-right: 1px;">-/+</div>
                <div class="plusCircle" (click)="adjustExpirationDateForSelected(7)">7</div>
                <div class="plusCircle" (click)="adjustExpirationDateForSelected(30)">30</div>
                <div class="plusCircle" (click)="adjustExpirationDateForSelected(90)">90</div>
            </div>
        </div>
    </div>
</div>

<div style="display: flex; gap: 10px; margin-left: 15px;">
    <div style="min-width: 300px;">
        <div style="padding: 5px; border: 1px solid lightgray; margin-bottom: 5px;">
            <div>
                <label style="padding-bottom: 2px; font-size: 16px; font-weight: 500;">Select Date Range</label>
            </div>
            <div>
                <label style="padding-bottom: 4px; font-size: 14px;">Showing: {{searchedScoutviews.length}} of {{totalScoutviewImageCount}}</label>
            </div>
            
            <div style="margin-bottom: 5px;">
                <button (click)="datesUpdated('Today')" class="btn btn-sm" style="color: rgb(0, 123, 255); padding-left: 0px;" type="button">Today</button>
                <button (click)="datesUpdated('Last 2 Days')" class="btn btn-sm" style="color: rgb(0, 123, 255);" type="button">Last 2</button>
                <button (click)="datesUpdated('Last 7 Days')" class="btn btn-sm" style="color: rgb(0, 123, 255);" type="button">Last 7</button>
                <input (datesUpdated)="datesUpdated('')" [(ngModel)]="selectedDateRange" [alwaysShowCalendars]="true" [isInvalidDate]="isInvalidDate"
                        [linkedCalendars]="true" [ranges]="ranges" [showClearButton]="true" [showCustomRangeLabel]="true" autocomplete="off"
                        ngxDaterangepickerMd placeholder="Select Date Range" type="text" style="width: 100%; font-size: small; border: 1px solid lightgray;" />
            </div>    
        </div>

        <div style="padding: 0px; border: 1px solid lightgray; max-height: 400px; margin-bottom: 5px;">
            <p-table #mediaSourcesTable [columns]="imageDeviceCols" [scrollable]="true" scrollHeight="300px" sortField="name" [value]="imageDevices">
                <ng-template pTemplate="caption">
                    <div style="text-align: left; margin-left: -12px; padding: 0px;">
                        <label style="margin-left: 10px; font-size: 15px; margin-bottom: 10px;">Scoutview Gateways</label>
                        <div style="display: flex; margin-left: 10px;">
                            <i class="fa fa-search" style="margin: 8px 8px 0 0"></i>
                            <input type="text" pInputText placeholder="Search gateways" (input)="mediaSourcesTable.filterGlobal($event.target.value, 'contains')" style="border: 1px solid lightgray; width: 100%; height: 30px">    
                        </div>
                    </div>
                </ng-template>
                <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                    <tr style="min-height: 40px; margin-left: -12px; font-size: 14px; background-color: white;" >
                        <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                            <div [style.--alive-color]="rowData.aliveColor" style="display: inline-block;">
                                <p-checkbox [(ngModel)]="rowData.isSelected" binary="true" id="{{rowData.id}}" name="{{rowData.id}}"
                                            [ngModelOptions]="{standalone: true}" styleClass="alive-checkbox"
                                            (ngModelChange)="imageSourceSelected(rowData)" ></p-checkbox>
                            </div>
                        </td>

                        <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px; padding-left: 0px;">
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <div *ngIf="rowData.userFeatureAccess['ViewDevice']" (click)="openCameraSettingsControls(rowData.name)" class="kig-link" style="cursor: pointer;">
                                    {{ rowData.name }}
                                </div>
                                <div *ngIf="!rowData.userFeatureAccess['ViewDevice']" >
                                    {{ rowData.name }}
                                </div>
                                <span style="color: gray; font-size: 12px; margin-left: 6px; white-space: nowrap;">(<span class="kig-link" style="cursor: pointer;" (click)="onGatewayRangeCountClicked(rowData)">{{ rowData.rangeCount }}</span>/<span class="kig-link" style="cursor: pointer;" (click)="onGatewayTotalCountClicked(rowData)">{{ rowData.imageCount }}</span>)</span>
                            </div>

                            <div *ngIf="rowData.isSelected" style="font-size: 11px; color: gray; margin-top: 2px;">
                                Expire:
                                3d=<span class="kig-link" style="cursor: pointer; text-decoration: none;" (click)="loadExpiringImagesForGateway(rowData, 3)">{{ rowData.expiring3d }}</span>,
                                3w=<span class="kig-link" style="cursor: pointer; text-decoration: none;" (click)="loadExpiringImagesForGateway(rowData, 21)">{{ rowData.expiring3w }}</span>,
                                3m=<span class="kig-link" style="cursor: pointer; text-decoration: none;" (click)="loadExpiringImagesForGateway(rowData, 90)">{{ rowData.expiring3m }}</span>
                            </div>
                        </td>

                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div style="padding: 0px; border: 1px solid lightgray; max-height: 400px;">
            <p-table #mediaTagsTable [columns]="imageTagCols" [scrollable]="true" scrollHeight="300px" sortField="name" [value]="imageTags">
                <ng-template pTemplate="caption">
                    <div style="text-align: left; margin-left: -12px; padding: 0px;">
                        <label style="margin-left: 10px; font-size: 15px; margin-bottom: 10px;">Media Tags</label>
                        <div style="display: flex; margin-left: 10px;">
                            <i class="fa fa-search" style="margin: 8px 8px 0 0"></i>
                            <input type="text" pInputText placeholder="Search media tags" (input)="mediaTagsTable.filterGlobal($event.target.value, 'contains')" style="border: 1px solid lightgray; width: 100%; height: 30px">    
                        </div>
                    </div>
                </ng-template>
                <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                    <tr style="height: 40px; margin-left: -12px; font-size: 14px; background-color: white;" >
                        <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px; padding: 10px;">
                            <p-checkbox [(ngModel)]="rowData.isSelected" binary="true" id="{{rowData.name}}" name="{{rowData.name}}" [ngModelOptions]="{standalone: true}" (ngModelChange)="imageTagsFiltered()" ></p-checkbox>
                        </td>

                        <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px; margin-left: 5px; padding: 0 5px 0 0;">
                            {{ rowData.name }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

    </div>

    <div style="width: 100%;" >
        <tabset>
            <tab heading="View Searched Images">
                <div class="row card-group" style="width: 100%;">
                    <div *ngFor="let scoutview of searchedScoutviews; let i = index" style="width: 326px; margin-top: 10px;">
                        <div class="card bg-light mb-3" [ngStyle]="{'border': (scoutview.selected) ? '1px solid red' : '1px solid darkgray'}">

                            <div [svLazyThumbnail]="scoutview" (downloadImage)="downloadSvImageForViewing($event, $event.latestThumbnail, false)" class="card-body" style="padding: 0rem">
                                <div *ngIf="scoutview.latestThumbnail.isLoading || scoutview.image.isLoading == true" style="display: flex; margin-top:130px">
                                    <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="margin: 10px;"></i>
                                    <span style="padding-top: 15px;">Loading...</span>
                                </div>

                                <!-- Latest thumbnail view -->
                                <ng-container *ngIf="!scoutview.showOriginal">
                                    <div *ngIf="scoutview.latestThumbnail.blobName.endsWith('.jpg') && scoutview.latestThumbnail.isLoading == false" style="width: 100%;" >
                                        <div *ngIf="!scoutview.latestThumbnailIsForMP4" class="card flex justify-content-center" style="border: 0px;">
                                            <img src="{{scoutview.latestThumbnail.source}}" alt="Image" style="width: 100%; cursor: pointer;" (click)="openFullscreenViewer(scoutview, 'latest')" />
                                        </div>
                                        <div *ngIf="scoutview.latestThumbnailIsForMP4 && scoutview.image.isLoading == false" class="card flex justify-content-center" style="border: 0px;">
                                            <div *ngIf="scoutview.image.source == ''" class="card flex justify-content-center" style="border: 0px; cursor: pointer;" (click)="showMedia(scoutview, scoutview.image, false, false)">
                                                <img src="{{scoutview.latestThumbnail.source}}">
                                                <i class="fa-solid fa-play" style="display: block; position: absolute; top: 72px; left: 141px; font-size: 38px;"></i>
                                                <i class="fa-regular fa-circle" style="display: block; position: absolute; top: 61px; left: 122px; font-size: 60px; color: lightgray;"></i>
                                            </div>
                                            <div *ngIf="scoutview.image.source != '' && scoutview.image.isLoading == false" class="card flex justify-content-center" style="border: 0px;">
                                                <video width="300" controls>
                                                    <source src="{{scoutview.image.source}}" type="video/mp4">
                                                </video> 
                                            </div>
                                        </div>
                                    </div>

                                    <div *ngIf="scoutview.latestThumbnail.blobName.endsWith('.mp4') && scoutview.latestThumbnail.isLoading == false" style="width: 100%;" >
                                        <video width="300" controls>
                                            <source src="{{scoutview.latestThumbnail.source}}" type="video/mp4">
                                        </video>
                                    </div>
                                </ng-container>

                                <!-- Original thumbnail view -->
                                <ng-container *ngIf="scoutview.showOriginal">
                                    <div *ngIf="scoutview.origThumbnail.isLoading" style="display: flex; margin-top:130px">
                                        <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="margin: 10px;"></i>
                                        <span style="padding-top: 15px;">Loading...</span>
                                    </div>
                                    <div *ngIf="scoutview.origThumbnail.blobName.endsWith('.jpg') && scoutview.origThumbnail.isLoading == false" style="width: 100%;" >
                                        <div class="card flex justify-content-center" style="border: 0px;">
                                            <img src="{{scoutview.origThumbnail.source}}" alt="Original Image" style="width: 100%; cursor: pointer;" (click)="openFullscreenViewer(scoutview, 'original')" />
                                        </div>
                                    </div>
                                    <div *ngIf="scoutview.origThumbnail.blobName.endsWith('.mp4') && scoutview.origThumbnail.isLoading == false" style="width: 100%;" >
                                        <video width="300" controls>
                                            <source src="{{scoutview.origThumbnail.source}}" type="video/mp4">
                                        </video>
                                    </div>
                                </ng-container>

                            </div>
                            
                            <div style="background-color: rgb(226, 226, 226); height: 30px; display: flex; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                                <div class="far fa-trash-alt" style="color: #c8102e; cursor: pointer; font-size: 16px; margin-top: 7px;" aria-hidden="true" (click)="onDeleteImageConfirm(scoutview)"></div>                                
                                <div *ngIf="!scoutview.showOriginal" class="fa-solid fa-image" style="color: #1c4966; cursor: pointer; font-size: 16px; margin-top: 7px;" aria-hidden="true" title="Show Original" (click)="toggleImageView(scoutview)"></div>
                                <div *ngIf="scoutview.showOriginal" class="fa-solid fa-images" style="color: #1c4966; cursor: pointer; font-size: 16px; margin-top: 7px;" aria-hidden="true" title="Show Latest" (click)="toggleImageView(scoutview)"></div>
                                <div class="fa-solid fa-share-nodes" style="color: #548235; cursor: pointer; font-size: 16px; margin-top: 7px;" aria-hidden="true" (click)="runPipelinePreviewer(scoutview, pipelinePrevewTemplate)"></div>                                
                                <div *ngIf="scoutview.expandedMetadata" class="fa-solid fa-circle-chevron-up" style="color: black; cursor: pointer; font-size: 16px; margin-top: 7px;" aria-hidden="true" (click)="expandMetadataView(scoutview)"></div>
                                <div *ngIf="!scoutview.expandedMetadata" class="fa-solid fa-circle-chevron-down" style="color: black; cursor: pointer; font-size: 16px; margin-top: 7px;" aria-hidden="true" (click)="expandMetadataView(scoutview)"></div>
                                <div *ngIf="scoutview.selected" class="far fa-check-square" style="color: black; cursor: pointer; font-size: 16px; margin-top: 7px;" aria-hidden="true" (click)="selectScoutview(scoutview)"></div>
                                <div *ngIf="!scoutview.selected" class="far fa-square" style="color: black; cursor: pointer; font-size: 16px; margin-top: 7px;" aria-hidden="true" (click)="selectScoutview(scoutview)"></div>
                            </div>

                            <div style="font-size: 13px; padding-left: 4px; overflow: hidden; overflow-y: scroll;" [ngStyle]="{'height': (scoutview.expandedMetadata) ? '200px' : '100px'}" >
                                <label style="color: darkkhaki;">Source Name: </label> {{ scoutview.svMetadata.sourceName }}<br>
                                <label style="color: darkkhaki;">Source ID: </label> {{ scoutview.svMetadata.sourceId }}<br>
                                <label style="color: darkkhaki;">Created: </label> {{ scoutview.svMetadata.captureDate | date : 'medium' }}<br>
                                <label style="color: darkkhaki;">Pipeline: </label> <div [innerHtml]="scoutview.svMetadata.pipelineInfo | svPipeline"></div>
                                <div style="display: flex;">
                                    <label style="color: darkkhaki;">Expires: </label> &nbsp; {{ scoutview.expireDays | number:'3.0-0' }} days
                                    <div style="width: 10px;"></div>
                                    <div *ngIf="scoutview.expireDays >= 90" class="minusCircle" (click)="adjustExpirationDate(scoutview, -90)">90</div>
                                    <div *ngIf="scoutview.expireDays < 90" class="minusCircleDisabled">90</div>
                                    <div *ngIf="scoutview.expireDays >= 30" class="minusCircle" (click)="adjustExpirationDate(scoutview, -30)">30</div>
                                    <div *ngIf="scoutview.expireDays < 30" class="minusCircleDisabled">30</div>
                                    <div *ngIf="scoutview.expireDays >= 7" class="minusCircle" (click)="adjustExpirationDate(scoutview, -7)">7</div>
                                    <div *ngIf="scoutview.expireDays < 7" class="minusCircleDisabled">7</div>
                                    <div style="margin-left: 6px; margin-right: 1px;">-/+</div>
                                    <div class="plusCircle" (click)="adjustExpirationDate(scoutview, 7)">7</div>
                                    <div class="plusCircle" (click)="adjustExpirationDate(scoutview, 30)">30</div>
                                    <div class="plusCircle" (click)="adjustExpirationDate(scoutview, 90)">90</div>
                                </div>
                                <label style="color: darkkhaki;">Modified: </label> {{ scoutview.svMetadata.modifiedDate | date : 'medium' }}<br>
                                <label style="color: darkkhaki;">Image Size: </label> {{ scoutview.svMetadata.imageDimensions }}<br>
                                <label style="color: darkkhaki;">Tags: </label> {{ scoutview.svMetadata.tags.join(', ') }}<br>
                            </div>
                        </div>
                    </div>
                </div>

            </tab>

            <tab heading="Metadata" >
                <p-table #metadataTable [columns]="metadataCols" [scrollable]="true" sortField="name" [value]="searchedScoutviews" scrollHeight="55vh">
                    <ng-template pTemplate="caption">
                        <div style="text-align: left; margin-top: 10px; margin-bottom: 10px;">
                            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                            <input (input)="metadataTable.filterGlobal($event.target.value, 'contains')" pInputText placeholder="Search Metadata" size="30"
                                    style="width:auto; height: 35px" type="text" >
                        </div>
                    </ng-template>
        
                    <ng-template let-columns pTemplate="header">
                        <tr>
                            <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                                {{col.header}}
                                <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
        
                    <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                        <tr style="height: 40px;" >
                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.svMetadata.captureDate | date : 'medium' }}
                            </td>
        
                            <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.svMetadata.expireDate | date : 'medium' }}
                            </td>
        
                            <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.svMetadata.modifiedDate | date : 'medium' }}
                            </td>
        
                            <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.svMetadata.sourceId }}
                            </td>
        
                            <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.svMetadata.sourceName }}
                            </td>
        
                            <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
                                <div class="css-tooltip" [attr.tooltip-data]="getToolTipText(rowData.svMetadata.tags)" style="font-size: 12px; cursor: pointer;">-List-</div>
                            </td>
                                    
                            <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.svMetadata.imageDimensions }}
                            </td>
                                    
                            <td [ngStyle]="{'width': columns[7].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.svMetadata.gpsLocation }}
                            </td>
                                    
                            <td [ngStyle]="{'width': columns[8].width}" style="flex: none; border-width: 0px;">
                                <!-- {{ rowData.svMetadata.svPipelineSequence.join(',') }} -->
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </tab>

            <tab heading="Pipelines" >
                <p-table #pipelineTable [columns]="mediaPipelineCols" [scrollable]="true" sortField="name" [value]="mediaPipelineInfos" scrollHeight="76vh">
                    <ng-template pTemplate="caption">
                        <div style="text-align: left; margin-top: 10px; margin-bottom: 10px;">
                            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                            <input (input)="pipelineTable.filterGlobal($event.target.value, 'contains')" pInputText placeholder="Search Pipelines" size="30" style="width:auto; height: 35px" type="text" >
                            <button [disabled]="!checkedImageDevice || !checkedImageDevice.userFeatureAccess['EditDevice']" (click)="createPipeline()" style="height: 38px; width: 150px; margin-top: -6px; margin-left: 10px; " class="btn btn-success" type="button">Create Pipeline</button>
                        </div>
                    </ng-template>
        
                    <ng-template let-columns pTemplate="header">
                        <tr>
                            <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                                {{col.header}}
                                <!-- <p-sortIcon *ngIf="col.header =='Name' || col.header == 'Active' || col.header == 'Media Source'" [field]="col.field"></p-sortIcon> -->
                            </th>
                        </tr>
                    </ng-template>
        
                    <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                        <tr style="height: 40px;" >
                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.name }}
                            </td>
        
                            <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.description }}
                            </td>
        
                            <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                                <div class="css-tooltip" [attr.tooltip-data]="getToolTipForNumProcessesText(rowData)" style="font-size: 12px; cursor: pointer;">{{ rowData.numProcesses }}</div>
                            </td>
        
                            <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                                <div *ngIf="rowData.isActive">
                                    <i (click)="updatePipelineIsActive(rowData, false)" class="fas fa-check-circle" style="color:#64a70b; font-size: 16px; cursor: pointer;"></i>
                                </div>
                                <div *ngIf="!rowData.isActive">
                                    <i (click)="updatePipelineIsActive(rowData, true)" class="fa-regular fa-circle" style="color:lightgray; font-size: 16px; cursor: pointer;"></i>
                                </div>
                            </td>
        
                            <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.sourceName }}
                            </td>
                
                            <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.lastRunDate  | date : 'medium' }}
                            </td>

                            <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;">
                                <div (click)="copyPipeline(rowData)" aria-hidden="true" class="pi pi-copy" style="color:#1c4966; cursor: pointer; font-size: 14px;"></div>
                            </td>
        
                            <td [ngStyle]="{'width': columns[7].width}" style="flex: none; border-width: 0px;">
                                <div (click)="editPipeline(rowData)" aria-hidden="true" class="fas fa-pencil-alt text-center" style="color:#64a70b; cursor: pointer; font-size: 14px;">
                            </div>
                            </td>
        
                            <td [ngStyle]="{'width': columns[8].width}" style="flex: none; border-width: 0px;">
                                <div (click)="onDeleteConfirm(rowData)" aria-hidden="true" class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;"></div>
                            </td>

                        </tr>
                    </ng-template>
                </p-table>
            </tab>
            <tab heading="Image Favorites" [active]="openImageFavoritesTab" (selectTab)="onImageFavoritesTabSelected()" (deselect)="onImageFavoritesTabDeselected()">
                <div style="margin: 10px; display: flex; gap: 12px; align-items: center; flex-wrap: wrap;">
                    <label style="margin-bottom: 0;">Image Favorites</label>
                    <div class="form-group" style="margin-bottom: 0; min-width: 320px; max-width: 700px; flex: 1;">
                        <ng-select [items]="imageFavorites" bindLabel="name" bindValue="id" [multiple]="true"
                                   [closeOnSelect]="false" placeholder="Select image favorites to display"
                                   [(ngModel)]="selectedImageFavoriteIds" (change)="onImageFavoriteSelectionChange()">
                        </ng-select>
                    </div>
                    <button type="button" class="btn btn-success" (click)="openImageFavoriteEditor()">New</button>

                    <label style="margin-bottom: 0; margin-left: 20px;">Size:</label>
                    <input type="radio" [(ngModel)]="imageFavoritesSize" name="imageFavoritesSize" value="Small"  (ngModelChange)="onImageFavoritesSizeChange()" /> <label style="margin-bottom: 0;">Small</label>
                    <input type="radio" [(ngModel)]="imageFavoritesSize" name="imageFavoritesSize" value="Medium" (ngModelChange)="onImageFavoritesSizeChange()" /> <label style="margin-bottom: 0;">Medium</label>
                    <input type="radio" [(ngModel)]="imageFavoritesSize" name="imageFavoritesSize" value="Large"  (ngModelChange)="onImageFavoritesSizeChange()" /> <label style="margin-bottom: 0;">Large</label>
                </div>

                <div *ngIf="imageFavoritesTabActive" style="display: flex; flex-wrap: wrap; gap: 12px; margin: 10px;">
                    <div *ngFor="let imageFavorite of selectedImageFavorites; trackBy: trackImageFavoriteById"
                         class="card bg-light" style="max-width: 100%;">
                        <kig-image-favorite [imageFavorite]="imageFavorite"
                                            [size]="imageFavoritesSize"
                                            [username]="username"
                                            [labelsEditable]="imageFavoriteLabelsEditable(imageFavorite)"
                                            (labelsEditModeChange)="onImageFavoriteLabelsEditModeChange(imageFavorite, $event)">
                        </kig-image-favorite>
                        <div style="display: flex; gap: 14px; justify-content: flex-end; padding: 4px 8px;">
                            <small class="text-muted" style="margin-right: auto;">{{ imageFavorite.userGroup }}</small>
                            <div *ngIf="canEditImageFavorite(imageFavorite)" (click)="openImageFavoriteEditor(imageFavorite)" aria-hidden="true"
                                 class="fas fa-pencil-alt" title="Edit image favorite" style="color:#64a70b; cursor: pointer; font-size: 14px;"></div>
                            <div *ngIf="canDeleteImageFavorite(imageFavorite)" (click)="onDeleteImageFavoriteConfirm(imageFavorite)" aria-hidden="true"
                                 class="far fa-trash-alt" title="Delete image favorite" style="color:#c8102e; cursor: pointer; font-size: 14px;"></div>
                        </div>
                    </div>
                    <small *ngIf="selectedImageFavorites.length === 0" class="text-muted">
                        Select one or more image favorites above, or click New to create one.
                    </small>
                </div>
            </tab>

        </tabset>
    </div>
</div>


<ng-template #pipelinePrevewTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="pipelinePreview-modal">
    <!-- <div class="modal-content pipelinePreview-modal"> -->
      <div style="background-color: #548235;  height: 7px;"></div>
      <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 style="color: rgb(10, 10, 10); text-transform: none;">Apply Pipeline Process</h5>
        <button
            (click)="pipelinePreviewRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
        </button>
      </div>

      <div class=" modal-body" style="margin-top: -1px;">
        <div style="margin-bottom: 20px; display: flex; gap: 20px;">
            <div class="form-group" style="width: 300px;">
                <label for="original" style="margin-bottom: 10px; font-weight: 500;">Original</label>
                <div [svLazyThumbnail]="scoutview" (downloadImage)="showMedia(scoutview, scoutview.origThumbnail, false, true)" >
                    <div *ngIf="scoutview.origThumbnail.isLoading" style="display: flex; margin-top:180px">
                        <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="margin: 10px;"></i>
                        <span style="padding-top: 15px;">Loading...</span>
                    </div>
                    <div *ngIf="scoutview.origThumbnail.blobName.endsWith('.jpg') && scoutview.origThumbnail.isLoading == false" style="width: 100%;" >
                        <img src="{{scoutview.origThumbnail.source}}" class="img-scale-down" (click)="selectScoutview(scoutview)"/>
                    </div>
                    <div *ngIf="scoutview.origThumbnail.blobName.endsWith('.mp4') && scoutview.origThumbnail.isLoading == false" style="width: 100%;" >
                        <video width="300" controls>
                            <source src="{{scoutview.origThumbnail.source}}" type="video/mp4">
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div *ngIf="scoutview.origThumbnail.blobName.endsWith('.webm') && scoutview.origThumbnail.isLoading == false" style="width: 100%;" >
                        <video width="300" controls>
                            <source src="{{scoutview.origThumbnail.source}}" type="video/webm">
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            </div>

            <div class="form-group" style="width: 300px;">
                <label for="Latest" style="margin-bottom: 10px; font-weight: 500;">Results</label>
                <div [svLazyThumbnail]="scoutview" (downloadImage)="showMedia(scoutview, scoutview.latestThumbnail, false, true)">
                    <div *ngIf="scoutview.latestThumbnail.isLoading" style="display: flex; margin-top:180px">
                        <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="margin: 10px;"></i>
                        <span style="padding-top: 15px;">Loading...</span>
                    </div>
                    <div *ngIf="scoutview.latestThumbnail.blobName.endsWith('.jpg') && scoutview.latestThumbnail.isLoading == false" style="width: 100%;" >
                        <img src="{{scoutview.latestThumbnail.source}}" class="img-scale-down" (click)="selectScoutview(scoutview)"/>
                    </div>
                    <div *ngIf="scoutview.latestThumbnail.blobName.endsWith('.mp4') && scoutview.latestThumbnail.isLoading == false" style="width: 100%;" >
                        <video width="300" controls>
                            <source src="{{scoutview.latestThumbnail.source}}" type="video/mp4">
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div *ngIf="scoutview.latestThumbnail.blobName.endsWith('.webm') && scoutview.latestThumbnail.isLoading == false" style="width: 100%;" >
                        <video width="300" controls>
                            <source src="{{scoutview.latestThumbnail.source}}" type="video/webm">
                            Your browser does not support the video tag.
                        </video>
                    </div>

                </div>
            </div>
        </div>

        <div style="margin-bottom: 10px; display: flex; gap: 10px;">
            <div class="form-group" style="width: 560px;">
                <label for="MediaSource" style="font-weight: 500;">Pipelines</label>
                <ngx-select-dropdown name="MediaSource" [config]="mediaPipelineConfig" [options]="mediaPipelineInfos" [(ngModel)]="selectedMediaPipeline" ></ngx-select-dropdown>
            </div>
            <button (click)="runSelectedPipeline()" class="btn btn-primary btn-sm" style="margin-top: 24px; height: 35px; width: 100px;" type="button">Run</button>
        </div>

        <div *ngIf="scoutview.pipelineResults != undefined && scoutview.pipelineResults.details != undefined" style="margin-bottom: 10px;">
            <label style="margin-bottom: 5px; display:block;">Finished Successfully: {{ scoutview.pipelineResults.finishedSuccessfully }}</label>
            <label style="margin-bottom: 5px; display:block;">Overall Results: {{ scoutview.pipelineResults.overallResults }}</label>
            <label style=" display:block;">Details</label>
            <label *ngFor="let result of scoutview.pipelineResults.details | keyvalue" style="margin-right: 10px; margin-left: 15px; display:block;">{{result.key}} = {{result.value}}</label>
        </div>

      </div>
    </div>
</ng-template>



<ng-template #metadataTagsTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="updateMetadataTags-modal">
      <div style="background-color: #548235;  height: 7px;"></div>
      <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 style="color: rgb(10, 10, 10); text-transform: none;">Update Tags for Selected Media</h5>
        <button
            (click)="updateMetadataTagsRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
        </button>
      </div>

      <div class=" modal-body" style="margin-top: -1px;">

        <div class="form-group" style="margin-bottom: 20px;">
            <label for="addTags" style="margin-bottom: 5px; font-weight: 500;">Tags to ADD to selected media</label>
            <input name="addTags" id="addTags" type="text" pInputText placeholder="List tags to add separated by commas" [(ngModel)]="tagsToAdd" style="border: 1px solid lightgray; width: 100%; height: 30px" autofocus>    
        </div>
        <div class="form-group" >
            <label for="removeTags" style="margin-bottom: 5px; font-weight: 500;">Tags to REMOVE from selected media</label>
            <input name="removeTags" id="removeTags" type="text" pInputText placeholder="List tags to remove separated by commas" [(ngModel)]="tagsToRemove" style="border: 1px solid lightgray; width: 100%; height: 30px">    
        </div>

        <button (click)="updateMetadataTagsForSelectedMedia()" class="btn btn-primary" style="margin-top: 24px; height: 35px; width: 100px; float: right; margin-bottom: 20px;" type="button">Update</button>

      </div>
    </div>
</ng-template>


<ng-template #runPipelineOnSelectedTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="updateMetadataTags-modal">
      <div style="background-color: #548235;  height: 7px;"></div>
      <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 style="color: rgb(10, 10, 10); text-transform: none;">Choose Pipeline Process to Run on Selected Images</h5>
        <button
            (click)="updateMetadataTagsRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
        </button>
      </div>

      <div class=" modal-body" style="margin-bottom: 10px; display: flex; gap: 10px;">
        <div class="form-group" style="width: 560px;">
            <label for="MediaSource" style="font-weight: 500;">Pipelines</label>
            <ngx-select-dropdown name="MediaSource" [config]="mediaPipelineConfig" [options]="mediaPipelineInfos" [(ngModel)]="selectedMediaPipeline" ></ngx-select-dropdown>
        </div>
        <button (click)="runPipelineOnSelectedMedia()" class="btn btn-primary btn-sm" style="margin-top: 24px; height: 35px; width: 100px;" type="button">Run</button>
      </div>
    </div>
</ng-template>